import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-2v4',
  templateUrl: './2v4.component.html',
})
export class VbGeneral2v4Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
